<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>Edit Offer Course</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                    <v-autocomplete @change="getOffSub()" rounded outlined dense v-model="list_selected_ay"
                        :items="list_ay" item-text="ay" label="Academic year" persistent-hint return-object
                        single-line></v-autocomplete>
                </v-col>
            </v-row>
            <v-row justify="center" dense v-if="this.selected.length > 0">
                <!-- <v-col cols="12" sm="2" md="2" class="p-0 m-0">
                <strong>Total Selected - {{ selected.length }}</strong>
              </v-col> -->
                <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                    <v-autocomplete rounded outlined dense v-model="courserule" :items="rulelist" item-text="name"
                        item-value="id" label="Type" persistent-hint single-line></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                    <v-text-field rounded type="number" outlined dense v-model="credit" label="Credit"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                    <v-autocomplete rounded outlined dense v-model="entrytype" :items="entrytype_list" item-text="name"
                        item-value="id" label="Marks Entry Type" persistent-hint single-line></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                    <v-autocomplete rounded outlined dense v-model="show_marksheet" :items="show_list" item-text="name"
                        item-value="id" label="Show In Marksheet" persistent-hint single-line></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                    <v-autocomplete rounded outlined dense v-model="cont_ass_not_applicable" :items="con_ass_list"
                        item-text="name" item-value="id" label="Cont. Assess. Not Applicable" persistent-hint
                        single-line></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                    <v-text-field rounded type="number" outlined dense v-model="passing_marks" label="Passing Marks"></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" md="2" class="p-0 m-0">
                    <v-btn class="button"
                        v-if="credit || courserule || entrytype || show_marksheet || cont_ass_not_applicable || passing_marks"
                        @click="apply()">Apply</v-btn>
                </v-col>
            </v-row>

            <v-row justify="center" v-if="this.selected.length > 0">
                <strong>Total Selected - {{ selected.length }}</strong>
            </v-row>
            <v-data-table v-if="list_selected_ay" :headers="headers" @current-items="getFiltered" :items-per-page="-1"
                :items="bookList1" dense sort-by="" class="elevation-1 mytable" :search="search" show-select
                v-model="selected" item-key="coff_id">
                <template v-slot:top class="pb-5">
                    <v-row justify="center" align="center">
                        <tr class="t-row">
                            <div>
                                <th>
                                    <v-row>
                                        <span v-for="header in headers" :key="header.text">
                                            <span v-if="filters.hasOwnProperty(header.value)">
                                                <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded
                                                    dense outlined color="#0F2027" :label="header.text" multiple
                                                    clearable :items="columnValueList(header.value)"
                                                    v-model="filters[header.value]"></v-autocomplete>
                                            </span>
                                        </span>
                                    </v-row>
                                </th>
                            </div>
                        </tr>
                    </v-row>
                </template>

                <template v-slot:[`item.sort_order`]="{ item }">
                    <v-row dense>
                        <v-col cols="12" md="5" sm="5">
                            <v-text-field type="number" dense class="pt-3" persistent-hint label="Enter Sort Order"
                                outlined rounded v-model="item.sort_order"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" sm="3">
                            <v-btn rounded class="button mt-5" dense small :loading="loader"
                                @click="updateSortOrder(item)">Update</v-btn>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:[`item.show_in_lc`]="{ item }">
                    <v-switch v-model="item.show_in_lc" @change="saveShowInLC(item)"></v-switch>
                </template>
                <template v-slot:item.show_in_marksheet="{ item }">
                    <span v-if="item.show_in_marksheet">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
                <template v-slot:item.cont_ass_not_applicable="{ item }">
                    <span v-if="item.cont_ass_not_applicable">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
            </v-data-table>

        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },

    data: () => ({
        loader: false,
        errorMsg: {},
        search: "",
        snackbar_msg: "",
        color: "",
        // extraBreadcrumbItems: [


        // ],
        breadcrumbClass: "breadcrumb-style1",
        snackbar: false,
        load: false,
        dialog: false,
        filterArr: [],
        filters: {
            standard: [],
            subjectcode: [],
            subject: [],
        },
        show_list: [
            { name: "Yes", id: "0" },
            { name: "No", id: "1" },
        ],
        con_ass_list: [
            { name: "Yes", id: "0" },
            { name: "No", id: "1" },
        ],
        show_marksheet: null,
        cont_ass_not_applicable: null,
        headers: [
            { text: "Sr. No.", value: "srno" },
            { text: "Subject Code", value: "subjectcode" },
            { text: "Subject", value: "subject" },
            { text: "Subject Rule", value: "subjectrule" },
            { text: "Credit", value: "credit" },
            { text: "Passing Marks", value: "passing_marks" },
            { text: "Marks Entry Type", value: "entrytype" },
            { text: "Academic Year", value: "academicyear" },
            { text: "Standard", value: "standard" },
            { text: "Show In Marksheet", value: "show_in_marksheet" },
            { text: "Show In LC", value: "show_in_lc" },
            { text: "Cont. Assess. Not Applicable ?", value: "cont_ass_not_applicable" },
            { text: "Edit Sort Order", value: "sort_order", width: 500 }
        ],
        show_studnts: false,
        search: null,
        selected: [],
        rulelist: "",
        courserule: null,
        aylist: "",
        ay: null,
        list_ay: [],
        list_selected_ay: null,
        courseofferinglist: [],
        credit: null,
        passing_marks: null,
        total_offer: [],
        overlay: false,
        entrytype_list: [], entrytype: ""
    }),
    computed: {
        bookList1() {
            return this.courseofferinglist.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },
    },
    mounted() {
        this.getsubjectoffering();
    },

    methods: {
        async saveShowInLC(item) {
            this.loader = true
            const data = {
                coff_id: item.coff_id,
                show_in_lc: item.show_in_lc,
            };
            this.overlay = true;
            try {
                const res = await axios.post("/Examination/updateLCFlag", data);
                if (res.data.flag == "Yes") {
                    this.showSnackbar("green", "Updated Successfully..");
                    this.getOffSub(this.list_selected_ay)

                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.overlay = false;
            } finally {
                this.overlay = false;
                this.loader = false
            }
        },
        async updateSortOrder(item) {
            this.loader = true
            const data = {
                coff_id: item.coff_id,
                sort_order: item.sort_order,
            };
            this.overlay = true;
            try {
                const res = await axios.post("/Examination/UpdateSortOrder", data);
                if (res.data.flag == "YES") {
                    this.showSnackbar("green", "Updated Successfully..");
                    this.getsubjectoffering()

                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.overlay = false;
            } finally {
                this.overlay = false;
                this.loader = false
            }
        },
        async apply() {
            for (var i = 0; i < this.selected.length; i++) {
                this.total_offer.push(this.selected[i].coff_id);
            }
            const data = {
                courserule: this.courserule,
                credit: this.credit,
                passing_marks: this.passing_marks,
                selected: this.total_offer,
                marksentrytype: this.entrytype,
                show_marksheet: this.show_marksheet,
                cont_ass_not_applicable: this.cont_ass_not_applicable

            };
            this.overlay = true;
            try {
                const res = await axios.post("/Examination/saveCrs_Rule_Credit", data);
                if (res.data.flag == "YES") {
                    this.showSnackbar("green", "Saved Successfully..");
                    this.getsubjectoffering()

                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.overlay = false;
            } finally {
                this.overlay = false;
                this.selected = [];
                this.total_offer = [],
                this.list_selected_ay = null;
                this.credit = null;
                this.courserule = null;
                this.passing_marks = null;
            }
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.courseofferinglist.map((d) => d[val]);
        },
        getOffSub() {
            //  console.log(this.list_selected_ay)
            this.courseofferinglist = []
            this.courseofferinglist = this.list_selected_ay.courseofferinglist
            //  console.log(this.courseofferinglist)
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        getsubjectoffering() {
            axios
                .post("/Examination/subjectoffering")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.aylist = res.data.aylist;
                        this.rulelist = res.data.rulelist;
                        // this.courseofferinglist = res.data.courseofferinglist;
                        this.list_ay = res.data.list_ay;
                        this.load = true;
                        this.ay = res.data.curr_ay;
                        this.entrytype_list = res.data.entrytype_list;
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                });
        },
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}</style>

